import React, { useContext } from 'react';
import { AppContext } from '@/utils/appContext';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { deleteItemToCart } from '@/utils/requests';
import { useNavigate, useParams } from 'react-router-dom';
import { ExclamationTriangle } from '@vectopus/atlas-icons-react';
import { g, gEventRemoveFromCartArg } from '@/utils/helpers';

const ModalDeleteItem = () => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { uuid }: any = useParams();
  const navigate = useNavigate();

  const removeItem = () => {
    if (appContext.itemToRemove) {
      deleteItemToCart(appContext.itemToRemove.cart_id, appContext.itemToRemove.item_id).then((response) => {


        g('event', 'remove_from_cart_v2', gEventRemoveFromCartArg(appContext));


        appContext.cart = appContext.cart.filter((cart) => cart.item_id !== appContext.itemToRemove?.item_id);
        appContext.setCart(appContext.cart);
        if (uuid && appContext.itemToRemove?.item_id === uuid) {
          navigate('/');
        }
      });
    }
    appContext.setOpenModalDeleteItem(false);
  };

  return (
    <Modal
      open={appContext.openModalDeleteItem}
      onClose={() => console.log('')}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        className={classes.root}
        p={3}>
        <Grid item xs={12}>
          <Box className={classes.iconContainer}>
            <ExclamationTriangle size={44} />
          </Box>
        </Grid>
        <Grid item xs={12} mt={3}>
          <Typography variant={'h4'} component={'h4'}>{t('Sure_to_delete_holiday?')}</Typography>
          <Typography variant={'body1'} component={'p'} mt={1}>{t('Have_to_start_search_again')}</Typography>
        </Grid>

        <Grid
          container
          alignItems={'center'}
          justifyContent={'space-evenly'}
          direction={'row'}
          spacing={3}
          mt={3}
        >
          <Grid item xs={12} sm={6}>
            <Button fullWidth variant={'contained'} color={'primary'} className={classes.secondaryBtn}
                    onClick={removeItem}>
              {t('Delete')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button fullWidth variant={'contained'} color={'primary'} className={classes.mainBtn}
                    onClick={() => appContext.setOpenModalDeleteItem(false)}>
              {t('Annulla')}
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </Modal>
  );
};
export default ModalDeleteItem;

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      width: 560,
      padding: 50,
      left: 0,
      top: '50%',
      position: 'absolute',
      right: 0,
      margin: 'auto',
      backgroundColor: 'white',
      transform: 'translate(0,-50%)',
      textAlign: 'center',
      '.MuiListItem-root': {
        alignItems: 'center',
        cursor: 'pointer'
      },
      '.MuiAvatar-root': {
        backgroundColor: 'transparent'
      },
      [theme.breakpoints.down('sm')]: {
        width: '85%',
        padding: 30,
        h4: {
          fontSize: 18
        },
        p: {
          lineHeight: '20px'
        }
      }
    },
    iconContainer: {
      width: 90,
      height: 90,
      textAlign: 'center',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#FFEE00',
      borderRadius: '50%',
      margin: 'auto'
    },
    secondaryBtn: {
      border: '1px solid #B32D24',
      backgroundColor: '#B32D24',
      color: '#FFF',
      '&:hover': {
        backgroundColor: '#B32D24'
      }
    },
    mainBtn: {
      backgroundColor: '#FFF',
      border: '1px solid #000',
      color: '#000',
      '&:hover': {
        color: '#FFF',
        backgroundColor: '#000'
      }
    }
  };
});
